<template>
	<div id="PerfilComponent" class="text-left menu-component">
		<h4 class="mb-4">Perfil</h4>

		<div class="form-group mb-4">
			<label for="userEmail">
				Email de contato
				<i
					title="Este é o e-mail que aparecerá por padrão em seu site."
					class="fas fa-question-circle pointer"
				></i>
			</label>
			<input
        @blur="checkErroEmail('userEmail')"
        v-model.trim="userData.userEmail"
        type="email"
        id="userEmail"
        class="form-control"
      />
      <p class="errors" v-if="errors.userEmail">{{errors.userEmail}}</p>
		</div>

		<div class="form-group mb-4">
			<label for="mainEmail">
				Email de orçamento
				<i
					title="Este é o e-mail que receberá os formulários de contato dos seus clientes."
					class="fas fa-question-circle pointer"
				></i>
			</label>
			<input
        @blur="checkErroEmail('mainEmail')"
        v-model.trim="userData.mainEmail"
        type="email"
        id="mainEmail"
        class="form-control"
       />
       <p class="errors" v-if="errors.mainEmail">{{errors.mainEmail}}</p>
		</div>

		<div class="form-group mb-4">
			<form action="" autocomplete="off">
				<label for="map">Qual seu endereço?</label>
				<input
					class="form-control default_input"
					placeholder="Pesquisar..."
					v-model="userData.address"
					v-gmaps-searchbox="searchResponse"
					@change="clearAdress"
					autocomplete="off"
				/>
			</form>
			<p v-if=" (userData.location.lat == null || userData.location.lng == null) && userData.address"
				class="error_message m-0"
			>
				<small>
					Endereço inválido. Não será possível exibir o mapa. Tente selecionar
					outro endereço.
				</small>
			</p>
		</div>

		<div class="form-group mb-4">
			<p>
				Telefone de contato
			</p>

			<div class="row text-left mb-3">
				<div class="col-4 mb-3">
					<span class="subtext">
						<small>DDI</small>
					</span>
					<DDISelect v-if="userData.idd > 0" :cId="userData.idd" @getCountry="getCountry($event)" />
				</div>

				<div class="col-8 mb-3">
					<span class="subtext">
						<small>Telefone (DDD + Número)</small>
					</span>
					<the-mask
						v-if="userData.idd == 30"
						type="tel"
						class="form-control hide-placeholder"
						:mask="['(##)####-####', '(##)#####-####']"
						placeholder="DDD + número"
						v-model="userData.contactPhone"
						@blur.native="verifyNumber"
					/>
					<the-mask
						v-else
						:mask="'############'"
						type="tel"
						class="form-control hide-placeholder"
						placeholder="DDD + número"
						v-model="userData.contactPhone"
					/>
					<p v-if="errorAlert" class="error_alert">
						<small>Número de telefone inválido.</small>
					</p>
				</div>

				<div class="col-12" v-if="app != 5">
					<span class="subtext">
						<small>Tipo de botão</small>
					</span>
					<b-form-group>
						<b-form-radio-group v-model="userData.whatsappIndex">
							<b-form-radio
							class="whatsapp-options pb-0"
							v-for="(option, index) in whatsOptions"
							name="whatsOption"
							:key="index"
							:value="option.value"
							>
								<span class="pointer">{{ option.label }}</span>
							</b-form-radio>
						</b-form-radio-group>
					</b-form-group>

					<template v-if="userData.whatsappIndex == 6">
						<div class="row m-0 menu-component">
							<div class="col-12 pl-0 mb-2">
								<label for="title-whatsapp">Texto do botão</label>
								<input
									type="text"
									name="whatsapp"
									id="whatsapp"
									class="form-control"
									placeholder="Digite o título do botão"
									v-model="userData.whatsappButton"
								/>
							</div>
							<div class="col-12 pl-0">
								<label for="message-whatsapp">Texto da mensagem</label>
								<input
									type="text"
									name="message-whatsapp"
									id="message-whatsapp"
									class="form-control"
									placeholder="Digite a mensagem padrão do chat"
									v-model="userData.whatsappMessage"
								/>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from "axios";
import DDISelect from "./Country";
import UserSubsegmentManager from "@/components/molecules/UserSubsegmentManager";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
	name: "PerfilComponent",
	data() {
		return {
			searchResponse: {
				search: "",
				place: "",
			},
			app: 5,
      errors: {},
			userData: {
				address: "",
				userEmail: null,
				activeSegment: null,
				activeSubsegments: [],
				userArtisticName: null,
				siteDescription: null,
				userTags: [],
				contactPhone: null,
				whatsappMessage: null,
				whatsappIndex: null,
				idd: null,
				location: {
					lat: null,
					lng: null,
				},
			},
			listFilter: [],
			choseOne: true,
			errormessage: "",
			addTagModal: false,
			newTag: null,
			errorAlert: false,
			fields:['formatted_address','utc_offset_minutes'],
			idd: {default: 30},
			whatsOptions: [
			{
				label: "Desativado",
				text: "Desativado",
				value: 0,
				message: "",
			},
			{
				label: "Agendar",
				text: "Agendar",
				value: 1,
				message: "Olá, qual dia e horario quer agendar?",
			},
			{
				label: "Fazer Pedido",
				text: "Fazer Pedido",
				value: 2,
				message: "Olá, qual o seu pedido?",
			},
			{
				label: "Encomendar",
				text: "Encomendar",
				value: 3,
				message: "Olá, faça sua encomenda.",
			},
			{
				label: "Chama no Whats",
				text: "Chama no Whats",
				value: 4,
				message: "Olá, como posso ajudar?",
			},
			{
				label: "Pedir Orçamento",
				text: "Pedir Orçamento",
				value: 5,
				message: "Olá, vamos fazer seu orçamento?",
			}
		]
		};
	},
	components: {
		VueGoogleAutocomplete,
		UserSubsegmentManager,
    	DDISelect
	},
	beforeCreate() {

	},
	created() {
		this.app = this.$store.state.application.id;

		this.updateData();
	},
	methods: {
    checkErroEmail(mailType){
      this.$delete(this.errors,mailType);
       let errorDescription = mailType === 'userEmail'
        ? "Email de contato obrigatório"
        : "Email de orçamento obrigatório";
      if (!this.userData.userEmail || !this.userData.mainEmail) {
        this.$set(this.errors, mailType, errorDescription);
      }
    },
		getCountry(event) {
			this.userData.idd = event;
		},
		verifyNumber() {
			if (this.userData.whatsappIndex != 0) {
				const minMobileBrazilNumberLength = 10;
				if (this.userData.contactPhone.length >= minMobileBrazilNumberLength) {
					this.errorAlert = false;
				} else {
					this.errorAlert = true;
				}
			} else {
				this.errorAlert = false;
			}
		},
		loseFocus() {
			this.userData.address = this.$refs.userAddres.autocompleteText;
			this.userData.location.lat = null;
			this.userData.location.lng = null;
		},
		notAddressFound(addressData) {
			this.userData.location.lat = null;
			this.userData.location.lng = null;
			this.userData.address = addressData.name;
		},
		getAddressData(addressData, placeResultData, id) {
			this.userData.location.lat = addressData.latitude;
			this.userData.location.lng = addressData.longitude;
			this.userData.address = placeResultData.formatted_address;
		},
		updateData() {
			let totalData = "";
			let token = this.$session.get("jwt");
			axios({
				method: "get",
				url: `${process.env.ROOT_API}/api/site/${this.siteId}`,
				data: totalData,
				headers: {
					Authorization: "Bearer " + token,
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}).then((response) => {
				this.searchResponse.search = response.data.address;

				this.userData.address = response.data.address;
				this.userData.userEmail = response.data.contactEmail;
				this.userData.mainEmail = response.data.mainEmail;
				this.userData.contactPhone = response.data.contactPhone;
				this.userData.whatsappButton = response.data.whatsappButton;
				this.userData.whatsappMessage = response.data.whatsappMessage;
				this.userData.whatsappIndex = response.data.whatsappIndex;
				this.userData.idd = response.data.country ?? this.$store.state.application.default_idd;
				this.userData.location = null;

				var item = {
						label: "Personalizado",
						text: "Chama no Whats",
						value: 6,
						message: "Olá, como posso ajudar?",
				};

				if (response.data.whatsappIndex == 6) {
					item = {
						label: "Personalizado",
						text: response.data.whatsappButton,
						value: 6,
						message: response.data.whatsappMessage,
					};
				}

				this.whatsOptions.push(item);

				if (response.data.location) {
					this.userData.location = response.data.location;
				}
				this.userData.activeSegment = this.$store.state.siteActive.segment.segment;
			});
		},
		focusMyElement,
		clearAdress(){
			this.userData.address = this.searchResponse.search;
			this.userData.location.lat = null;
			this.userData.location.lng = null;
		}
	},
	props: {
		saveData: { type: Boolean },
		siteId: { type: Number },
	},
	watch: {
		saveData() {
			if (this.saveData == true) {
				this.errormessage = "";
				this.userData.activeSubsegments = this.$store.state.siteActive.segment.subSegments;
				var updadeProfile = this.userData;
				let token = this.$session.get("jwt");
				axios({
					method: "post",
					url: `${process.env.ROOT_API}/api/site/${this.siteId}/update/contact`,
					data: updadeProfile,
					headers: {
						Authorization: "Bearer " + token,
						// 'Content-Type': 'application/x-www-form-urlencoded'
					},
				})
				.then((response) => {
					if (response.data.status == 1) {
						this.$emit("updateMenuOption");
					} else {
						this.errormessage = response.data.error;
						this.$emit("resetSaveData");
					}
				})
				.catch((response) => {
					//handle error
					this.errormessage = response.data.error;
				});
			}
		},
		searchResponse: {
			handler: function (val, oldVal) {
				if (this.searchResponse.place) {
					this.userData.address = this.searchResponse.place.formatted_address;
					
					this.userData = {
						...this.userData,
						location: {
							lat: this.searchResponse.place.geometry.location.lat(),
							lng: this.searchResponse.place.geometry.location.lng(),
						},
					}
				}
			},
			deep: true,
		},
		'userData.whatsappIndex': function() {
			if (this.idd === 30) {
				this.verifyNumber();
			}
		},
		'userData.whatsappMessage': function() {
			this.whatsOptions[6].text = this.customText;
		},
		'userData.whatsappButton': function() {
			this.whatsOptions[6].message = this.userData.whatsappButton;
		},
	},
};

function focusMyElement(e) {
	this.$refs.focusThis.focus();
}
</script>

<style scoped>
.whatsapp-options {
  display: block;
  border-top: none !important;
  border-bottom: none !important;
}
.custom-control-input:focus {
  outline-offset: none !important;
}
.error_alert {
  color: #d61a1a;
}
.form-control {
  background-color: transparent;
}
.ap-input:hover ~ .ap-input-icon,
.ap-input:focus ~ .ap-input-icon,
.ap-input-icon:hover {
	display: none !important;
}
.ap-input,
.ap-hint {
	border: none;
	border-bottom: 1px solid #dddddd;
	border-radius: 0;
}
.error_message {
	color: #d61a1a;
}
#newTag {
	background-color: #ffff !important;
}
.item-seo {
	border-radius: 25px;
	padding: 3px 12px;
	margin: 5px 3px 5px 0;
	display: inline-block;
	font-size: 14px;
	border: 1px solid #dddddd;
}
.item-seo i:hover,
.add-item-seo:hover,
.item--segment {
	cursor: pointer;
}
.item--segment:hover {
	font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/PerfilComponent.vue